import React from 'react'
import { Badge, Button, Dropdown } from 'antd'
import { LuListFilter } from "react-icons/lu";

const FiltersMenu = ({ menu, disabled = false }: { menu: () => JSX.Element, disabled?: boolean }) => {
    return (
        <Dropdown dropdownRender={menu} trigger={["click"]} disabled={disabled}>
            <Badge count={disabled ? 0 : 1} className="ms-2" color="blue">
                <Button  disabled={disabled}>
                    <LuListFilter />
                </Button>
            </Badge>
        </Dropdown>
    );
}

export default FiltersMenu;
